// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"c962ca32","703":"965eb45b"}[chunkId] + ".chunk.js";
};